import Initialize from 'picnic/core/commands/Initialize';
import View from 'app/cms/search/views/Search';
import TagsCollection from 'app/cms/search/collections/Tags';


class Command extends Initialize {
	get settings() {
		var
			settings = {
				selector: '.content-search',
				namespace: 'search:views',
				viewclass: View
			}
		;

		if (window.kleinanzeigen && window.kleinanzeigen.search && window.kleinanzeigen.search.taglist) {
			settings.viewoptions = {
				tags: new TagsCollection(window.kleinanzeigen.search.taglist)
			};
		}

		return settings;
	}
}

export default Command;
